/**
 * @param {number} schoolYear
 * @param {number} endMonth 
 * @returns a string date in YYYY-MM-DD format corresponding to the last day of the provided `endMonth` for the provided `schoolYear`
 */
export function getReportEndDate(schoolYear, endMonth) {
  const reportEndYear = endMonth > 6 ? schoolYear : schoolYear + 1,
    reportEndMonth = String(endMonth).padStart(2, '0'),
    reportEndDay = getLastDayForMonth(endMonth, reportEndYear)
  return `${reportEndYear}-${reportEndMonth}-${reportEndDay}`
}

/**
 * @param {number} month
 * @param {number} year 
 * @returns either 28, 29, 30, or 31 based on the given `year` and `month`
 */
function getLastDayForMonth(month, year) {
  if (month === 2) {
    // account for leap years
    return year % 4 === 0 ? 29 : 28
  }
  return [1, 3, 5, 7, 8, 10, 12].includes(month) ? 31 : 30
}